import React from "react";
import styleCustom from "./style.module.scss";
import Spinner from "../Spinner/Spinner";

type CustomButtonType = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  backgroundColor?: string;
  color?: string;
  style?: React.CSSProperties;
  isLoading?: boolean;
  variant?: "primary" | "secondary";
};

export const CustomButton = ({
  children,
  className,
  backgroundColor,
  color,
  style,
  isLoading,
  disabled,
  variant,

  ...props
}: CustomButtonType) => {
  return (
    <>
      {!variant || variant === "primary" ? (
        <button
          className={`${styleCustom.custom_button__wrapper} ${
            variant === "primary" ? styleCustom.custom_button__primary : ""
          } ${className}`}
          {...props}
          style={{
            backgroundColor: disabled
              ? "#DBDBDB "
              : backgroundColor ?? "#0560fd",
            color: color ?? "#fff",
            cursor: disabled ? "not-allowed" : "pointer",
            ...style,
          }}
          disabled={isLoading || disabled}
        >
          {isLoading ? <Spinner /> : children}
        </button>
      ) : (
        <button
          className={`${styleCustom.custom_button__secondary} ${className}`}
          {...props}
          style={{
            backgroundColor: disabled ? "#F5F5F5" : backgroundColor ?? "#fff",
            color: color ?? "#0560fd",
            border: "solid #0560fd 1px",
            cursor: disabled ? "not-allowed" : "pointer",
            ...style,
          }}
          disabled={isLoading || disabled}
        >
          {isLoading ? <Spinner /> : children}
        </button>
      )}
    </>
  );
};
